import { Radio } from "antd";
import { FormPersonaNatural } from "../../PersonaNatural/components/Form";
import { FormPersonaJuridica } from "../../PersonaJuridica/components/FormJuridica";
import { FormGrupoConformado } from "../../GrupoConformado/components/FormGrupoConformado";

interface IProps {
  convocatoria: any;
  perfiles: any[];
  tipoParticipante: number | null;
  cambiarTipoParticipante: (tipo: number) => void;
  /** Se avisa al salir de cualquier campo de datos personales. */
  alSalirDeUnCampo: (participante: any) => void;
}

/** 1 natural, 2 juridica, 3 grupo conformado, como en el registro. */
const FORMULARIOS: { [tipo: number]: any } = {
  1: FormPersonaNatural,
  2: FormPersonaJuridica,
  3: FormGrupoConformado,
};

/**
 * Primer paso: con que perfil se presenta la persona y sus datos.
 *
 * Antes eran dos paginas, una para elegir el perfil y otra para el
 * formulario. Aqui el formulario aparece debajo en cuanto se elige, sin
 * cambiar de pantalla.
 */
export const Paso1Perfil = ({
  convocatoria,
  perfiles,
  tipoParticipante,
  cambiarTipoParticipante,
  alSalirDeUnCampo,
}: IProps) => {
  const Formulario = tipoParticipante ? FORMULARIOS[tipoParticipante] : null;

  return (
    <div className="container-fluid2">
      {/*
        El tipo de participante va solo en su fila, centrado. Todo dentro de
        una sola columna: en dos, el titulo y los radios caben uno al lado del
        otro y el titulo queda a un extremo y los radios al otro.
      */}
      <div className="row justify-content-center mt-4">
        {/*
          La columna va centrada, pero su contenido se alineaba a la
          izquierda dentro de ella, asi que el bloque quedaba a un lado. Se
          centra tambien el contenido.
        */}
        <div className="col-12 col-md-8 col-lg-6 text-center">
          <div className="mb-2 font-size-12px font-family-Montserrat-Bold font-color-4B4B4B">
            Tipo de participante <span style={{ color: "red" }}>*</span>
          </div>

          {perfiles.length === 0 ? (
            <span className="font-family-Montserrat-Regular font-size-12px font-color-4B4B4B">
              Esta convocatoria todavía no tiene perfiles habilitados.
            </span>
          ) : (
            <Radio.Group
              value={tipoParticipante}
              onChange={(e) => cambiarTipoParticipante(e.target.value)}
            >
              {perfiles.map(({ value, text }: any) => (
                <Radio className="font-family-Montserrat-Regular" key={value} value={value}>
                  {text}
                </Radio>
              ))}
            </Radio.Group>
          )}
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12">
          {Formulario ? (
            <Formulario
              convocatorias={convocatoria}
              alSalirDeUnCampo={alSalirDeUnCampo}
              mostrarNavegacion={false}
            />
          ) : (
            perfiles.length > 0 && (
              <span className="font-family-Montserrat-Regular font-size-14px font-color-4B4B4B">
                Elige un tipo de participante para continuar con tus datos.
              </span>
            )
          )}
        </div>
      </div>
    </div>
  );
};
